import React from "react";
import { CircularProgress } from "@mui/material";

interface MetaAdsCancelPlanModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export default function MetaAdsCancelPlanModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: MetaAdsCancelPlanModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/70 backdrop-blur-md flex items-center justify-center p-4 sm:p-6">
      <div className="relative w-full max-w-[850px] lg:h-[392px] h-[450px] rounded-[20px]  bg-[#0e0e10] overflow-hidden">
        {/* Red radial glow */}
        <div
          className="absolute inset-x-0 top-0 h-[260px] pointer-events-none"
          style={{
            background:
              "radial-gradient(ellipse 80% 70% at 40% -10%, rgba(200,20,20,0.85) 0%, rgba(140,5,5,0.5) 45%, rgba(8,10,16,0) 75%)",
          }}
        />

        <div className="relative z-10 px-6 sm:px-8 md:px-10 pt-7 sm:pt-9 pb-10 sm:pb-12">
          {/* Header */}
          <div className="flex items-start justify-between gap-4">
            <h2 className="text-white text-[24px] lg:text-[48px] lg:font-bold font-semibold">
              Cancel current plan?
            </h2>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close cancel plan modal"
              className="text-white/75 hover:text-white lg:text-[32px] text-[24px] mt-[-7px] lg:mt-0 leading-none mt-1 flex-shrink-0"
              disabled={isLoading}
            >
              ✕
            </button>
          </div>

          {/* Description */}
          <p className="mt-4 text-white text-[14px] lg:text-[16px]">
            Are you sure you want to cancel your active Meta ads builder tool
            subscription?
          </p>

          <p className="mt-3 text-white text-[14px] lg:text-[16px]">
            By canceling, you acknowledge that your current subscription is
            non-refundable. For any questions, please feel free to{" "}
            <a href="/contact-us" className="text-[#58F2A9] underline">
              contact us
            </a>
          </p>

          {/* Divider */}
          <div className="mt-8 sm:mt-10 w-full h-px bg-white/10" />

          {/* Buttons */}
          <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <button
              type="button"
              onClick={onConfirm}
              disabled={isLoading}
              className="inline-flex items-center justify-center h-[48px] sm:h-[52px] px-7 sm:px-8 rounded-full bg-[#FF2D2D] text-white text-[14px] lg:text-[16px] font-semibold "
            >
              {isLoading ? (
                <span className="inline-flex items-center gap-2">
                  <CircularProgress size={16} sx={{ color: "#fff" }} />
                  Canceling...
                </span>
              ) : (
                "Proceed and cancel"
              )}
            </button>

            <button
              type="button"
              onClick={onClose}
              disabled={isLoading}
              className="inline-flex items-center justify-center h-[48px] sm:h-[52px] px-7 sm:px-8 rounded-full bg-white text-[#111318] text-[14px] lg:text-[16px] font-semibold "
            >
              Keep using this tool
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
